import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from './../../jsCore/store/userStats/Stats.actions'
import { Stat } from './Stat.view'
import { get as getFromPdo } from './../../jsCore/application/pageDataObject'
import { identity as mapStateToProps } from './../../jsCore/utils/fn'
import { warn } from './../../jsCore/application/console'

class userStatsContainerComponent extends Component {
  componentDidMount() {
    this.fetchData()
  }

  fetchData() {
    const userId = this.getUserId()
    if (!userId) {
      warn(`UserId isn't in the PDO! (unable to fetch DATA for user-stats-component`)
    }

    this.props.fetchUserStats(userId)
  }

  getUserId() {
    return getFromPdo('page.user_id')
  }

  render() {
    const { postCreate, readsGot } = this.props.userStats

    return (
      <section className="user-stats">
        <Stat name="Articles" amount={postCreate} />
        <Stat name="Reads" amount={readsGot} />
      </section>
    )
  }
}

export function userStatsContainer({ componentName, stateKey }) {
  return {
    name: componentName,
    stateKey,
    component: connect(mapStateToProps, actions)(userStatsContainerComponent),
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/user_stats/Stats.container.js